<template>
	<div id="master">
		<app-topbar />

		<app-sidebar>
			<app-sidebar-item :to="{ name: 'search' }" icon="search" exact>
				{{ $t('nav.search') }}
			</app-sidebar-item>

			<app-sidebar-item :to="{ name: 'dashboard' }" icon="tachometer-alt" exact>
				{{ $t('nav.dashboard') }}
			</app-sidebar-item>

			<app-sidebar-item :to="{ name: 'clients' }" icon="building" v-if="showClientNav">
				{{ $t('nav.clients') }}
			</app-sidebar-item>

			<app-sidebar-item :to="{ name: 'connections' }" icon="link" exact v-if="showConnectionNav">
				{{ $t('nav.connections') }}
			</app-sidebar-item>

			<app-sidebar-item :to="{ name: 'translator-servers' }" icon="server" exact v-if="showTranslatorServerNav">
				{{ $t('nav.translator_servers') }}
			</app-sidebar-item>

			<app-sidebar-item :to="{ name: 'mag-templates' }" icon="columns" exact v-if="showMagTemplateNav">
				{{	$t('nav.mag_templates') }}
			</app-sidebar-item>

			<app-sidebar-item :to="{ name: 'users' }" icon="users" exact v-if="showUserNav">
				{{ $t('nav.users') }}
			</app-sidebar-item>

			<app-sidebar-item :to="{ name: 'roles' }" icon="user-tag" exact v-if="showRoleNav">
				Roles
			</app-sidebar-item>

			<app-sidebar-item :to="{ name: 'cw-monitor-errors' }" icon="exclamation-triangle" exact v-if="showMonitorErrorNav">
				Monitor Errors
			</app-sidebar-item>

			<app-sidebar-item icon="caret-square-right" slot="footer" v-if="appBarCollapsed" @click="expandSidebar()">
				{{	$t('nav.expand') }}
			</app-sidebar-item>

			<app-sidebar-item icon="caret-square-left" slot="footer" v-else @click="collapseSidebar()">
				{{	$t('nav.collapse') }}
			</app-sidebar-item>
		</app-sidebar>

		<div class="app-section" :class="{ 'app-bar-collapsed': appBarCollapsed }">
			<router-view />
		</div>
	</div>
</template>

<script>
import AppTopbar from '../../components/layout/AppTopbar';
import AppSidebar from '../../components/layout/AppSidebar';
import AppSidebarItem from '../../components/layout/AppSidebarItem';

export default {
	components: {
		AppTopbar,
		AppSidebar,
		AppSidebarItem
	},
	mounted () {
		this.$store.dispatch('settings/fetchSettings');
	},
	computed: {
		/**
		 * Returns the `isLoggedIn` property from the store
		 *
		 * @returns {boolean}
		 */
		isLoggedIn () {
			return this.$store.getters['auth/isLoggedIn'];
		},

		/**
		 * Returns the `appBarCollapsed` property from the store
		 *
		 * @returns {boolean}
		 */
		appBarCollapsed () {
			return this.$store.getters['ui/appBarCollapsed'];
		},
		showClientNav () {
			return this.$store.getters['auth/hasPermission']('view_client', false) || this.$store.getters['auth/hasPermission']('manage_client*', false);
		},
		showConnectionNav () {
			return this.$store.getters['auth/hasPermission']('view_connection') || this.$store.getters['auth/hasPermission']('manage_connection');
		},
		showTranslatorServerNav () {
			return this.$store.getters['auth/hasPermission']('view_translator_server') || this.$store.getters['auth/hasPermission']('manage_translator_server');
		},
		showMagTemplateNav () {
			return this.$store.getters['auth/hasPermission']('view_global_mag') || this.$store.getters['auth/hasPermission']('manage_global_mag');
		},
		showUserNav () {
			return this.$store.getters['auth/hasPermission']('view_user') || this.$store.getters['auth/hasPermission']('manage_user');
		},
		showMonitorErrorNav () {
			return this.$store.getters['auth/hasPermission']('view_monitor_error') || this.$store.getters['auth/hasPermission']('manage_monitor_error');
		},
		showRoleNav () {
			return this.$store.getters['auth/hasPermission']('view_role') || this.$store.getters['auth/hasPermission']('manage_role');
		}
	},

	methods: {
		collapseSidebar () {
			this.$store.commit('ui/setCollapsed', true);
		},

		expandSidebar () {
			this.$store.commit('ui/setCollapsed', false);
		},
		hasPermission (permissions) {
			for (const permission of permissions) {
				if (this.permissions.includes(permission)) {
					return true;
				}
			}
		}
	}
};
</script>

<style lang="scss">
@import '../../_variables';

.app-section {
	padding-top: $app-topbar-height;
	padding-left: $app-sidebar-width;

	&.app-bar-collapsed {
		padding-left: $app-sidebar-collapsed-width;
	}
}
</style>
